import request from '@/utils/request'


// 查询商品分类列表
export function platformCategoryList(data) {
  return request({
    url: '/biz/admin/goods/category/platform/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: data
  })
}


// 查询商品分类分页
export function platformCategoryPage(data) {
  return request({
    url: '/biz/admin/goods/category/platform/page',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: data
  })
}

// 查询商品分类树
export function platformCategoryTree(data) {
  return request({
    url: '/biz/admin/goods/category/platform/tree',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: data
  })
}



// 查询商品分类列表
export function merchantCategoryList(data) {
  return request({
    url: '/biz/admin/goods/category/merchant/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: data
  })
}

// 查询商品分类分页
export function merchantCategoryPage(data) {
  return request({
    url: '/biz/admin/goods/category/merchant/page',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: data
  })
}

// 查询商家商品分类树
export function merchantCategoryTree(data) {
  return request({
    url: '/biz/admin/goods/category/merchant/tree',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: data
  })
}

// 查询商家商品分类树(指定商家Id)
export function merchantIdCategoryTree(data) {
  return request({
    url: '/biz/admin/goods/category/merchant/id/tree',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: data
  })
}


// 查询商品分类详细
export function getCategory(data) {
  return request({
    url: '/biz/admin/goods/category/detail',
    method: 'post',
    data: data
  })
}

// 新增商品分类
export function addCategory(data) {
  return request({
    url: '/biz/admin/goods/category/add',
    method: 'post',
    data: data
  })
}

// 修改商品分类
export function updateCategory(data) {
  return request({
    url: '/biz/admin/goods/category/edit',
    method: 'post',
    data: data
  })
}

export function updateVisible(data) {
  return request({
    url: '/biz/admin/goods/category/visible',
    method: 'post',
    data: data
  })
}

// 删除商品分类
export function delCategory(data) {
  return request({
    url: '/biz/admin/goods/category/delete',
    method: 'post',
    data: data
  })
}


export function sortCategory(query) {
  return request({
    url: '/biz/admin/goods/category/sort',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}